module.exports = __webpack_public_path__ + "img/about_local_team_daily03.223a3959.png";